import React from 'react';

import { FooterLinkViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import BaseSelect from 'components/BaseForm/Select/BaseSelect';
import { FormInputProps } from 'components/BaseForm/types';
import { profileEnumMapping } from 'utils/enumData';

import BaseModalEdition from '../../Modals/ModalEdition/ModalEdition';
import {
  FooterLinkFormValue,
  footerLinkProfileValue,
  LINK_LABEL,
  PROFILE_LABEL,
  TEXT_LABEL,
} from '../types';

interface ModalEditionProps {
  close: () => void;
  visible: boolean;
  initials: FooterLinkFormValue;
  title: string;
  submit: (values: FooterLinkFormValue) => void;
  isSubmitting: boolean;
  validate: (
    field: FooterLinkViolationDtoFormFieldEnum,
    values: FooterLinkFormValue,
  ) => Promise<void>;
}

function ModalEdition({ ...props }: ModalEditionProps): React.ReactElement {
  const inputs: Array<
    FormInputProps<FooterLinkFormValue, FooterLinkViolationDtoFormFieldEnum>
  > = [
    {
      name: 'link',
      label: LINK_LABEL,
      field: FooterLinkViolationDtoFormFieldEnum.LINK,
      required: true,
    },
    {
      name: 'text',
      label: TEXT_LABEL,
      field: FooterLinkViolationDtoFormFieldEnum.TEXT,
    },
    {
      name: 'profile',
      label: PROFILE_LABEL,
      field: FooterLinkViolationDtoFormFieldEnum.PROFILE,
      render: () => {
        return (
          <BaseSelect
            allowClear
            options={footerLinkProfileValue}
            getOptionValue={option => option}
            getOptionLabel={option => profileEnumMapping[option].name}
          />
        );
      },
    },
  ];

  return <BaseModalEdition {...props} inputs={inputs} />;
}

export default ModalEdition;
